import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const Footer = () => {
    const [getGlobalData, setGlobalData] = useState({});
    const myGlobalData = useSelector((state) => state.globalData);

    useEffect(() => {
        if (myGlobalData && myGlobalData?.data) {
            const settingsData = JSON.parse(myGlobalData?.data);
            setGlobalData(settingsData);
        }
    }, [myGlobalData]);

    return (
        <div className="main-footer text-center">
            <div className="container">
                <div className="row row-sm">
                    <div className="col-md-12">
                        {/* <span>Copyright © 2023 <a href="/admin/dashboard">Event Management</a>. Designed by <a href="/admin/dashboard">Event Management</a> All rights reserved.</span> */}
                    <span>{getGlobalData?.settings?.copy_right_text}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;